import "./ManageWageAccountDDLTableStyle.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import React, { useEffect, useRef, useState } from "react";
import ArchiveIcon from "@mui/icons-material/Archive";;
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, RequestParams } from "@websential/cosmic-v20";

import { useSelector } from "react-redux";
import { useTheme } from "@mui/material";
import { IAppState } from "../../../../../store/reducers";

export interface IManageWageAccountDDLTable {
    rows: any;
    columns?: any;
    onRowDeleteClicked?: (params: any) => void;
    onRowEditClicked?: (params: any) => void;
    onRowArchiveClicked?: () => void;
    isLoading?: any;
    onRequestParamsChange?: (params: RequestParams) => void;
    initialPageSize?: number | undefined;
    initialPage?: number;
    totalRecords?: number;
    rowsPerPageOptions?: number[];
    tableScrollHeight?: string;
    showHeaderColumns?: boolean;
    showDeleteIcon?: boolean;
    disabledDeleteIcon?: boolean;
    showArchiveIcon?: boolean;
    showPaginator?: boolean;
    selectedId: string;
    showIndexColumn?: boolean;
}

export const ManageWageAccountDDLTable: React.FC<IManageWageAccountDDLTable> = ({
    rows,
    columns,
    onRowDeleteClicked,
    onRowEditClicked,
    onRowArchiveClicked,
    isLoading,
    onRequestParamsChange,
    initialPageSize = 10,
    initialPage = 0,
    totalRecords,
    rowsPerPageOptions,
    tableScrollHeight,
    showHeaderColumns = false,
    showDeleteIcon = true,
    disabledDeleteIcon = false,
    showArchiveIcon = true,
    showPaginator = true,
    selectedId,
    showIndexColumn,
}) => {
    const isInitialRequest = useRef(true);
    const [loading, setLoading] = useState(false);
    const theme = useTheme();
    const subMenuVisibility = useSelector(
        (state: IAppState) => state.drawerAction.subMenuVisibility
    );
    const [itemSearch, setItemSearch] = useState("");
    const [requestParams, setRequestParams] = useState<any>({
        first: initialPage,
        rows: initialPageSize,
        page: initialPage,
        sortField: null,
        sortOrder: "asc",
        searchQuery: "",
        filters: {
            name: { value: "", matchMode: "contains" },
            "country.name": { value: "", matchMode: "contains" },
            company: { value: "", matchMode: "contains" },
            "representative.name": { value: "", matchMode: "contains" },
        },
    });

    // const ArchiveIcon = () => (
    // 	<svg
    // 		xmlns="http://www.w3.org/2000/svg"
    // 		width="16"
    // 		height="16"
    // 		fill="currentColor"
    // 		viewBox="0 0 16 16"
    // 	>
    // 		<path d="M2.5 1a1 1 0 0 0-1 1v2a1 1 0 0 0 .293.707L3 5.914V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.914l1.207-1.207A1 1 0 0 0 14.5 4V2a1 1 0 0 0-1-1h-11zm1 6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8A.5.5 0 0 1 3.5 7z" />
    // 	</svg>
    // );
    const delEditArchive = (params: any) => {
        return (
            <>
                {/* <EnhancedButtonPrimeReact
                    icon={"pi pi-user-edit"}
                    onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
                    severity={EnhancedButtonPrimeReactSeverity.Secondary}
                    className="p-button-rounded p-button-text w-2rem h-2rem"
                    rounded
                /> */}
                {showArchiveIcon && (
                    <Button
                        icon={<ArchiveIcon />}
                        // icon={<ArchiveOutlinedIcon/>}
                        onClick={onRowArchiveClicked}
                        severity={EnhancedButtonPrimeReactSeverity.Secondary}
                        className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
                        style={{ fontSize: "16px", color: "grey" }}
                        rounded
                    />
                )}
                {showDeleteIcon && (
                    <EnhancedButtonPrimeReact
                        // icon="pi pi-trash"
                        icon="pi pi-times"
                        onClickHandler={() =>
                            onRowDeleteClicked && onRowDeleteClicked(params)
                        }
                        severity={EnhancedButtonPrimeReactSeverity.Danger}
                        className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
                        rounded
                        disabled={disabledDeleteIcon}
                    />
                )}
            </>
        );
    };
    const renderHeader = () => {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <span
                    className="p-input-icon-left w-full"
                    style={{ display: "flex", height: "37px" }}
                >
                    <i className="pi pi-search" />
                    <InputText
                        value={itemSearch}
                        onChange={(e) => setItemSearch(e.target.value)}
                        placeholder={"Search..."}
                        className="w-full"
                        style={{ borderRadius: "2px 2px 2px 2px" }}
                    />
                </span>
            </div>
        );
    };
    const headerSearch = renderHeader();
    function search(_row: any) {
        return (
            rows &&
            rows.filter(
                (rows: any) =>
                    rows.label.props.children
                        .toLowerCase()
                        .indexOf(itemSearch.toLowerCase()) > -1
            )
        );
    }

    const onPage = (event: any) => {
        // setRequestParams(event);
        setLoading(true);
        //imitate delay of a backend call
        setTimeout(() => {
            setRequestParams({
                ...event,
                // searchQuery: itemSearch,
            });
            setLoading(false);
        }, 1000);
    };

    useEffect(() => {
        // if the results fetcher was passed, we can use it to fetch the results.
        if (onRequestParamsChange) {
            // skip the first initial call
            if (isInitialRequest.current === true) {

                isInitialRequest.current = false;
            } else {

                onRequestParamsChange(requestParams);
            }
        }
    }, [onRequestParamsChange, requestParams]);

    const getRowClassName = (data: any) => {
        const isMatch = data.id && selectedId ?
            data.id === selectedId : data.value && selectedId ? data.value === selectedId : false;
        return {
            "highlighted-row": isMatch
        };
    };

    // const [selectedRow, setSelectedRow] = useState(null);
    // const getRowClassName = (rowData: any) => {
    // 	return rowData === selectedRow ? 'highlighted-row' : '';
    // };
    // useEffect(() => {
    // 	if (!selectedId) {
    // 		setSelectedRow(null)
    // 	}
    // }, [selectedId])

    return (
        <>
            <DataTable
                value={rows && rows && search(rows)}
                responsiveLayout="scroll"
                lazy
                // key={selectedId}
                paginator={showPaginator ? true : false}
                first={requestParams.first}
                rows={requestParams.rows}
                totalRecords={totalRecords}
                onPage={onPage}
                rowsPerPageOptions={rowsPerPageOptions}
                paginatorTemplate=" PrevPageLink PageLinks NextPageLink  CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
                scrollable
                scrollHeight={tableScrollHeight ? tableScrollHeight : "75vh"}
                loading={isLoading}
                header={headerSearch}
                emptyMessage="No Record found."
                className={`${showHeaderColumns ? "ManageWageAccountDDLTableWithHeaderColumns" : "ManageWageAccountDDLTableStyle"
                    }`}
                paginatorClassName={showPaginator ? "DDLPaginator" : ""}
                style={{
                    position: "sticky",
                    top: subMenuVisibility ? "170px" : "128px",

                    // ADD this:
                    maxHeight: `calc(100vh - ${subMenuVisibility ? "170px" : "128px"})`,
                }}
                // onRowClick={(e: any) => setSelectedRow(e.data)}
                rowClassName={getRowClassName}
            // onRowClick={onRowClickHandler}
            >
                {/* {rows && rows.length ? (
                    <Column
                        header="#"
                        className="indexColumn"
                        headerClassName="indexColumn"
                        headerStyle={{ width: "24px", }}
                        frozen
                        hidden={!showIndexColumn}
                        body={(data, options) => options.rowIndex + 1}
                    ></Column>
                ) : undefined} */}
                {/* <Column field={"label"} />
                {!columns && <Column field={"label"} body={labelBodyTemplate} />}
                <Column body={delEditArchive}></Column> */}
                {columns &&
                    columns.map((x: any, index: any) => (
                        <Column
                            key={index}
                            field={x.field}
                            header={x.headerName}
                            align={x.align}
                            style={{ fontSize: ".875rem" }}

                        />
                    ))}
                {/* {!columns && <Column field={"label"} />} */}
                {!columns && (
                    <Column
                        field={"label"}
                        body={(rowData) => {
                            const text = rowData.label?.props?.children ?? rowData.label ?? "";
                            return (
                                <span title={String(text)}>
                                    {rowData.label}
                                </span>
                            );
                        }}
                    />
                )}
                <Column
                    body={delEditArchive}
                    style={{
                        width:
                            showDeleteIcon && showArchiveIcon
                                ? "6.6em"
                                : showDeleteIcon || showArchiveIcon
                                    ? "2.8em"
                                    : "0",
                    }}
                />
            </DataTable>
        </>
    );
};
